// extracted by mini-css-extract-plugin
export default {"SwitchToTabButton":"ruWqJb9Q2wWV5tpBUF9n"};